import { endReducer } from '../store/Store';
import {
  ClearInspectionPhotos,
  DeleteInspectionPhoto,
  ReportInspectionPhotos,
  SaveInspectionQuestionData,
  TApiInspectionPhoto,
  TInspectionActions,
  TInspectionState,
  UploadInspectionPhoto,
} from '../types/Inspection';
import { Reducer } from 'redux';
import { filter } from 'lodash';

export const inspectionReducer: Reducer<
  TInspectionState,
  TInspectionActions
> = (state = {}, action) => {
  switch (action.type) {
    case SaveInspectionQuestionData.SET:
      return {
        ...state,
        status: action.payload.status,
      };
    case SaveInspectionQuestionData.SENT:
      return {
        ...state,
        sent: action.payload.sent,
      };
    case SaveInspectionQuestionData.PHOTO_SENT:
      return {
        ...state,
        photoSent: action.payload.photoSent,
      };
    case SaveInspectionQuestionData.TASK_SENT:
      return {
        ...state,
        taskSent: action.payload.taskSent,
      };
    case SaveInspectionQuestionData.SET_LOCATION:
      return {
        ...state,
        locationId: action.payload.locationId,
      };
    case SaveInspectionQuestionData.SET_QUESTIONS:
      return {
        ...state,
        questionId: action.payload.questionId
      }
    case UploadInspectionPhoto.SUCCESS:
      return {
        ...state,
        photos: state.photos
          ? [...state.photos, action.payload.data]
          : [action.payload.data],
      };
    case DeleteInspectionPhoto.SUCCESS:
      return {
        ...state,
        photos: filter(
          state.photos as Array<TApiInspectionPhoto>,
          (p) => p.id !== action.payload.data.photoId
        ),
      };

    case ReportInspectionPhotos.SUCCESS:
    case ClearInspectionPhotos.SUBMIT:
      return {
        ...state,
        photos: [],
      };
    default:
      return endReducer(state, action);
  }
};
